import { tw, theme as twTheme, Theme } from 'twind'
interface ThemeStyleOptions {
  rawValue?: boolean
}
function theme<Section extends keyof Theme>(
  prop: `${Section}.${string}`,
  options?: ThemeStyleOptions
) {
  // @ts-ignore
  const themeProp = tw(twTheme(prop))
  if (prop.startsWith('colors') && options?.rawValue) {
    const cssVar = themeProp.match(/\(([^)]+)\)/)![1]
    return `var(${cssVar}-raw)`
  }
  return themeProp
}
export default theme
